import { render } from "./UploadView.vue?vue&type=template&id=2649e4af&scoped=true"
import script from "./UploadView.vue?vue&type=script&lang=js"
export * from "./UploadView.vue?vue&type=script&lang=js"

import "./UploadView.vue?vue&type=style&index=0&id=2649e4af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2649e4af"]])

export default __exports__